import * as React from 'react';

function WaiverIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      fill="#333333"
      {...props}>
      <path d="M5.43 7.834a.562.562 0 0 0 0 1.125h6.032a.563.563 0 1 0 0-1.125H5.43Zm2.713 3.193H5.43a.562.562 0 0 0 0 1.125h2.712a.563.563 0 0 0 0-1.125Z" />
      <path d="M8.06 18.188H3.777a1.673 1.673 0 0 1-1.669-1.675V5.118a1.673 1.673 0 0 1 1.67-1.675H4.94v.141a1.49 1.49 0 0 0 1.488 1.487h5.375a1.49 1.49 0 0 0 1.488-1.487v-.141h1.156c.936 0 1.669.735 1.669 1.675v3.206a.563.563 0 0 0 1.125 0V5.119a2.8 2.8 0 0 0-2.794-2.8H13.29v-.144A1.49 1.49 0 0 0 11.802.688H6.429a1.49 1.49 0 0 0-1.489 1.487v.144H3.78a2.8 2.8 0 0 0-2.795 2.8v11.393a2.8 2.8 0 0 0 2.794 2.8H8.06a.563.563 0 0 0 0-1.125ZM6.065 2.174c0-.2.162-.362.362-.362h5.375c.2 0 .363.162.363.362v1.41c0 .2-.163.362-.363.362H6.428a.363.363 0 0 1-.362-.363V2.175Z" />
      <path d="M18.419 10.849c-.77-.77-2.115-.771-2.885 0l-4.987 4.987c-.16.16-.266.365-.304.588l-.274 1.619a1.088 1.088 0 0 0 1.255 1.254l1.618-.273c.224-.038.428-.143.589-.304l4.987-4.987a2.042 2.042 0 0 0 0-2.884Zm-5.764 7.066-1.576.314.264-1.598 3.575-3.574 1.294 1.294-3.557 3.564Zm4.967-4.977-.616.617-1.293-1.294.616-.617a.912.912 0 0 1 1.491.297.915.915 0 0 1-.198.996Z" />
    </svg>
  );
}
export default WaiverIcon;
